import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Accordion": Accordion, "@mui/material/AccordionActions": AccordionActions, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/Typography": Typography, "@mui/icons-material/ExpandMore": ExpandMoreIcon, "@mui/material/Button": Button } } });
export default ClientProvider;
